const PrimaryMarketSettlementEnum = Object.assign({
  FOP: 'FoP',
  STO: 'STO',
  STO_V2: 'STO_V2',
  LOAN: 'loan',
  BB_CLOSED_SHOP: 'bb_closed_shop',
  BLOCKER: 'blocker',
});

Object.freeze(PrimaryMarketSettlementEnum);

export default PrimaryMarketSettlementEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/PrimaryMarketSettlements.js